import axios from "../plugins/parseAxios";
export class ChatAPI {
  constructor(props) { }
  static createChat(payload) {
    return axios.post("functions/createChat", payload);
  }
}
